import classNames from 'classnames';
import {FC} from 'react';

import {Icon} from 'components/Icon/Icon';
import {Text} from 'components/Text/Text';

import styles from './CartFormDeliveryInfo.module.css';

type Props = {
    className?: string;
};
export const CartFormDeliveryInfo: FC<Props> = ({className}) => {
    return (
        <div className={classNames(styles.block, className)}>
            <div className={styles.main}>
                <Text.Bold12 className={styles.title}>
                    Скидки «КЛЕН» и «Деловые линии» на доставку заказов:
                </Text.Bold12>
                <div className={styles.groups}>
                    <div className={styles.group}>
                        <Text.Regular12 className={styles.label}>
                            Межтерминальная доставка
                        </Text.Regular12>
                        <Text.Bold12 className={styles.value}>-25%</Text.Bold12>
                    </div>
                    <div className={styles.group}>
                        <Text.Regular12 className={styles.label}>
                            Доставка по городу
                        </Text.Regular12>
                        <Text.Bold12 className={styles.value}>-30%</Text.Bold12>
                    </div>
                    <div className={styles.group}>
                        <Text.Regular12 className={styles.label}>
                            Жестяная упаковка
                        </Text.Regular12>
                        <Text.Bold12 className={styles.value}>-50%</Text.Bold12>
                    </div>
                    <div className={styles.group}>
                        <Text.Regular12 className={styles.label}>
                            Упаковка палетный борт
                        </Text.Regular12>
                        <Text.Bold12 className={styles.value}>
                            -100%
                        </Text.Bold12>
                    </div>
                </div>
            </div>
            <Icon name="deliveryCarSale" className={styles.deliveryIcon} />
        </div>
    );
};
